var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChromeSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 23.9994C20.4189 23.9994 24.0008 20.4175 24.0008 15.999C24.0008 11.5805 20.4189 7.99866 16.0004 7.99866C11.5819 7.99866 8 11.5805 8 15.999C8 20.4175 11.5819 23.9994 16.0004 23.9994Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07173 20.0012L2.1443 8.00256C0.739648 10.4347 9.69082e-05 13.1938 9.5232e-09 16.0024C-9.68892e-05 18.811 0.739267 21.5702 2.14374 24.0024C3.54823 26.4346 5.56832 28.4542 8.0009 29.8581C10.4335 31.262 13.1928 32.0006 16.0014 31.9999L22.9288 20.0012V19.9991C22.2272 21.2159 21.2175 22.2264 20.0013 22.9291C18.7852 23.6318 17.4054 24.0018 16.0009 24.002C14.5963 24.0022 13.2164 23.6326 12.0001 22.9303C10.7838 22.228 9.77373 21.2177 9.07173 20.0012Z",
    fill: "url(#paint0_linear_18_233)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9282 20.0003L16.0008 31.9989C18.8094 31.9993 21.5686 31.2603 24.001 29.856C26.4334 28.4518 28.4532 26.4319 29.8573 23.9995C31.2614 21.567 32.0004 18.8078 32 15.9992C31.9995 13.1905 31.2595 10.4316 29.8545 7.99963H15.9997L15.9979 8.0007C17.4025 7.99999 18.7825 8.36918 19.9991 9.07103C21.2157 9.77293 22.226 10.7828 22.9285 11.9991C23.631 13.2153 24.0008 14.5952 24.0008 15.9997C24.0007 17.4042 23.6307 18.784 22.9282 20.0003Z",
    fill: "url(#paint1_linear_18_233)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 22.3343C19.4981 22.3343 22.3338 19.4986 22.3338 16.0007C22.3338 12.5027 19.4981 9.66699 16.0001 9.66699C12.5021 9.66699 9.6665 12.5027 9.6665 16.0007C9.6665 19.4986 12.5021 22.3343 16.0001 22.3343Z",
    fill: "#1A73E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 8.00039H29.855C28.451 5.56787 26.4314 3.54784 23.9991 2.14345C21.5668 0.739063 18.8076 -0.000199299 15.999 4.03026e-08C13.1904 0.00019938 10.4313 0.739851 7.99926 2.14459C5.56714 3.54932 3.54779 5.56964 2.14417 8.00232L9.07157 20.001L9.07335 20.0019C8.37048 18.7859 8.00018 17.4063 7.99972 16.0017C7.99926 14.5971 8.3687 13.2172 9.07081 12.0007C9.77286 10.7843 10.7829 9.77409 11.9993 9.07188C13.2157 8.36963 14.5956 8.00009 16.0002 8.00039Z",
    fill: "url(#paint2_linear_18_233)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_233",
    x1: 17.7323,
    y1: 31.0006,
    x2: 3.87688,
    y2: 7.00229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E8E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A853"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_233",
    x1: 13.6662,
    y1: 32.0413,
    x2: 27.5216,
    y2: 8.04306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBC04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18_233",
    x1: 2.14417,
    y1: 10.0009,
    x2: 29.855,
    y2: 10.0009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA4335"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeSmall);
export default __webpack_public_path__ + "static/media/chrome-small.a8df65906af30e230d4fffc83294d97c.svg";
export { ForwardRef as ReactComponent };